module.exports = __webpack_public_path__ + "static/img/case_tab_15.3becb7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_15.png
// module id = xiOW
// module chunks = 34